import * as React from "react";
import type { SVGProps } from "react";
const SvgClearIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="clear_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M227.456 938.667A128 128 0 0 1 100.949 791.21l59.094-384a128 128 0 0 1 126.506-108.544h54.784v-85.334a170.667 170.667 0 0 1 341.334 0v85.334h54.784A128 128 0 0 1 863.957 407.21l59.094 384a128 128 0 0 1-126.507 147.456h-569.13zm199.21-725.334V320a64 64 0 0 1-64 64H286.55a42.667 42.667 0 0 0-42.197 36.181L230.272 512h563.499l-14.123-91.819A42.667 42.667 0 0 0 737.451 384h-76.118a64 64 0 0 1-64-64V213.333a85.333 85.333 0 1 0-170.666 0zm-209.535 384L185.3 804.181a42.667 42.667 0 0 0 42.112 49.152h369.92v-128a42.667 42.667 0 1 1 85.334 0v128h113.877a42.667 42.667 0 0 0 42.155-49.152l-31.83-206.848H217.173z"
    />
  </svg>
);
export default SvgClearIcon;
